import type React from 'react';

/** The space between two phase labels, in px. */
const PHASE_GAP_PX = 8;

/**
 * The phase labels of the rail with their place: each one is at most as wide as the space up to
 * the next label (the last one up to the end), so no two labels touch. Pure.
 */
export function railPhaseLabels(
  labels: ReadonlyArray<{ key: string; text: string }>,
  lefts: readonly number[]
): Array<{ key: string; text: string; style: React.CSSProperties }> {
  return labels.map((label, index) => {
    const left = lefts[index] ?? 0;
    const next = lefts[index + 1] ?? 100;
    const room = Math.max(0, next - left);
    return { ...label, style: { left: `${left}%`, maxWidth: `calc(${room}% - ${PHASE_GAP_PX}px)` } };
  });
}
